var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 8.5h-4.6v-.8A7.6 7.6 0 0 0 34.4 0c-4.8 0-7.7 3.3-9.4 6.3-1.7-3-4.7-6.3-9.5-6.3A7.6 7.6 0 0 0 8 7.7l.1.8H3.5A3.5 3.5 0 0 0 0 11.9v10a3.4 3.4 0 0 0 2.3 3.2v21.4A3.5 3.5 0 0 0 6 50H44a3.5 3.5 0 0 0 3.6-3.5V31a1.8 1.8 0 0 0-3.7 0v15.3H30.4v-21h16A3.5 3.5 0 0 0 50 22V12a3.5 3.5 0 0 0-3.4-3.5zm-12-4.8a4 4 0 0 1 3.7 4.8H28c1.2-2.3 3.2-4.8 6.4-4.8zm-22.8 4a4 4 0 0 1 3.8-4c3.2 0 5.3 2.5 6.5 4.8H11.8l-.1-.8zM6 25.4h13.6v21H6v-21zm20.8 21h-3.5v-21h3.5v21zm19.5-24.7H3.7v-9.5h42.6v9.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductUpdates);
export default __webpack_public_path__ + "static/media/product-updates.11481ed3.svg";
export { ForwardRef as ReactComponent };